export default "__VITE_ASSET__179fcb3a__"